RivalIQ.module('graph', function (graph, App, Backbone, Marionette, $, _, d3) {

    'use strict';

    DotGraph.prototype = new graph.Graph();

    function DotGraph(attrs) {
        this.base = graph.Graph;
        this.base(attrs);
    }

    graph.DotGraph = DotGraph;

    DotGraph.prototype.setMaxRows = function (maxRows) {
        this.maxRows = maxRows;
    };

    DotGraph.prototype.adjustLabels = function () {
        const me = this;
        d3.select(me.target).selectAll('.y-axis-label')
            .call(me.wrap, 200);
    };

    DotGraph.prototype.onAttachLoaded = function () {
        const me = this;
        me.adjustLabels();
    };

    DotGraph.prototype.render = function () {

        const width = this.width - this.margin.left - this.margin.right;
        const height = this.height - this.margin.top - this.margin.bottom;
        const DOT_WIDTH = 14;
        const DOT_HEIGHT = 14;
        const Y_DOT_PADDING = 4;
        const LABEL_HEIGHT = 12;
        const PIX_PER_CHAR = 7.5;
        const X_PADDING_PIXELS = 90;
        const Y_PADDING_PIXELS = 20;
        const X_PADDING_PERCENT = X_PADDING_PIXELS * 2 / width;
        const Y_PADDING_PERCENT = Y_PADDING_PIXELS * 2 / height;
        const Y_AXIS_POSITION = 8;
        const LABEL_TRIM_LENGTH = 12;
        const DRAW_DEBUG_RECT = false;
        let xticks = this.axisTicks;
        let yticks = this.axisTicks;
        const me = this;
        const isReadOnly = RivalIQ.state.user.isReadOnly();
        this.clearRendering();


        const x = d3.scale.linear()
            .range([0, width]);

        const y = d3.scale.linear()
            .range([height, 0]);
        //set up the domains
        let xmin = d3.min(this.data, function (d) {
            if (d.x) {
                return d.x;
            } else {
                return 0;
            }
        });
        let xmax = d3.max(this.data, function (d) {
            if (d.x) {
                return d.x;
            } else {
                return 0;
            }
        });
        let xrange = xmax - xmin;
        // if our range is collapsed to 0 or 1, then make sure we label the point(s)
        // and give it appropriate ticks
        if (xrange === 0 || xrange === 1) {
            xrange = xticks = xrange + 1;
        }
        // count how many distinct values we have for our axis labels
        const numXValues = _.uniq(this.data.map(function (item) {
            return me.formatX(item.x);
        })).length;
        const numYValues = _.uniq(this.data.map(function (item) {
            return me.formatY(item.y);
        })).length;

        // if we are going to not have enough values to populate our ticks, reduct our ticks
        if (numXValues < xticks) {
            xticks = numXValues;
        }

        xmin = xmin - xrange * X_PADDING_PERCENT;
        xmax = xmax + xrange * X_PADDING_PERCENT;


        let ymin = d3.min(this.data, function (d) {
            if (d.y) {
                return d.y;
            } else {
                return 0;
            }
        });
        let ymax = d3.max(this.data, function (d) {

            if (d.y) {
                return d.y;
            } else {
                return 0;
            }
        });
        let yrange = ymax - ymin;

        // if our range is collapsed to 0 or 1, then make sure we label the point(s)
        // and give it appropriate ticks
        if (yrange === 0 || yrange === 1) {
            yrange = yticks = yrange + 1;
        }
        // if we are going to not have enough values to populate our ticks, reduct our ticks
        if (numYValues < yticks) {
            yticks = numYValues;
        }
        ymin = ymin - (Y_PADDING_PERCENT * yrange);
        ymax = ymax + (Y_PADDING_PERCENT * yrange);

        x.domain([xmin, xmax]);
        y.domain([ymin, ymax]);

        const vis = d3.select(this.target)
            .append('svg')
            .attr('width', width + this.margin.left + this.margin.right)
            .attr('height', height + this.margin.top + this.margin.bottom)
            .append('g')
            .attr('transform', `translate(${this.margin.left},${this.margin.top})`);

        const xrule = vis.selectAll('g.x')
            .data(x.ticks(xticks))
            .enter().append('g')
            .attr('class', 'x axis');

        if (typeof this.xlabel !== 'undefined') {

            vis.append('text')
                .text(this.xlabel)
                .attr('x', width / 2)
                .attr('y', this.height - 15)
                .attr('text-anchor', 'middle');
        }
        if (typeof this.ylabel !== 'undefined') {
            const numCharsInYAxis = Math.ceil((this.formatY(ymax)).length);

            const AXIS_PIXELS_PER_CHAR = 7.5;
            const ylabelYpos = Y_AXIS_POSITION + AXIS_PIXELS_PER_CHAR * numCharsInYAxis + 15; //15 padding
            vis.append('text')
                .text(this.ylabel)
                .attr('class', 'y-axis-label')
                .attr('x', -height / 2)
                .attr('y', -ylabelYpos)
                .attr('dy', '-1')
                .attr('text-anchor', 'middle')
                .attr('transform', 'rotate(-90)');
        }

        xrule.append('text')
            .attr('x', x)
            .attr('y', this.height - 52)
            .attr('dy', '.71em')
            .attr('text-anchor', 'middle')
            .text(this.formatX);

        const yrule = vis.selectAll('g.y')
            .data(y.ticks(yticks))
            .enter().append('g')
            .attr('class', 'y axis');

        yrule.append('text')
            .attr('x', -Y_AXIS_POSITION)
            .attr('y', y)
            .attr('dy', '.35em')
            .attr('text-anchor', 'end')
            .text(this.formatY);

        vis.append('rect')
            .attr('class', 'dot-graph-background')
            .attr('width', width)
            .attr('height', height);


        const visTagList = [];
        const dotList = [];

        this.data.forEach(function (d) {
            // the width and height of the dot
            const newD = {};
            newD.x = x.invert(x(d.x) - DOT_WIDTH / 2);
            newD.y = y.invert(y(d.y) - DOT_HEIGHT / 2);
            newD.w = DOT_WIDTH;
            newD.h = DOT_HEIGHT;
            newD.label = d.label;
            visTagList.push(newD);
            dotList.push(newD);
        });

        const rectCollision = function (x0, y0, w0, h0, x1, y1, w1, h1) {

            if (x0 > (x1 + w1) || (x0 + w0) < x1) {
                return false;
            }

            return !(y0 > (y1 + h1) || (y0 + h0) < y1);

        };
        const shouldShow = function (d, collisionList, giveBestGuess) {
            let returnVal = true;

            // a flag to track if we found a place to put the label
            let foundIt = false;
            let collision;
            // a set of places we'd like to put the label relative to the dot
            const labelDeltas = [
                {
                    dx: 0,
                    dy: -1,
                    alignment: 'start'
                },
                {
                    dx: 1,
                    dy: 0,
                    alignment: 'start'
                },
                {
                    dx: -1,
                    dy: 0,
                    alignment: 'start'
                },
                {
                    dx: 0,
                    dy: 1,
                    alignment: 'start'
                },
                {
                    dx: -1,
                    dy: -1,
                    alignment: 'start'
                },
                // yes, this last entry is here twice so that in the best guess case, we end up with it
                {
                    dx: 0,
                    dy: -1,
                    alignment: 'start'
                }
            ];
            let i = 0;
            let dx;
            let dy;
            let labelAlign;
            let x0;
            let y0;
            let w0;
            let h0;
            let x1;
            let y1;
            let w1;
            let h1;

            // keep looking for an offset that works until we find one or exhaust our options
            while (!foundIt && i < labelDeltas.length) {

                collision = false;
                dx = labelDeltas[i].dx;
                dy = labelDeltas[i].dy;
                labelAlign = labelDeltas[i].alignment;
                h1 = LABEL_HEIGHT;
                w1 = PIX_PER_CHAR * me.trimOrdinalLabelWithFocus(d, LABEL_TRIM_LENGTH).length;

                // center the label
                if (dx === 0) {

                    x1 = x(d.x) - w1 / 2;
                }

                // move it to start just at the edge of the dot
                if (dx > 0) {

                    x1 = x(d.x) + DOT_WIDTH;
                }
                // move it to end at the left edge of the dot
                if (dx < 0) {
                    x1 = x(d.x) - w1 - DOT_WIDTH;
                }

                // the y position of the labels is with the top of the label at the midpoint of the circle.
                // adjust the vertical position of the label according to where it should go.
                // remember that dy > 0 is down the screen (upper left is 0,0)
                if (dy === 0) {
                    y1 = y(d.y) - LABEL_HEIGHT / 2;
                } else if (dy > 0) {
                    y1 = y(d.y) + DOT_HEIGHT / 2 + Y_DOT_PADDING;
                } else {
                    y1 = y(d.y) - DOT_HEIGHT / 2 - LABEL_HEIGHT - Y_DOT_PADDING;
                }

                collisionList.forEach(function (item) {
                    // the 0th thing is just some item in the list

                    x0 = x(item.x);
                    y0 = y(item.y);
                    w0 = item.w;
                    h0 = item.h;
                    // the first thing is always a label

                    if (rectCollision(x0, y0, w0, h0, x1, y1, w1, h1)) {
                        // if we collide with something else

                        collision = true;
                    } else if (x1 + w1 > width + X_PADDING_PIXELS) {
                        // else if we run off the right side
                        collision = true;


                    } else if (x1 < 0) {
                        // else if we run off the left side
                        collision = true;

                    }

                });
                foundIt = (!collision);
                i = i + 1;
            }

            // if we find a label we can place, stick it into the list of things to check
            // for collision
            if (foundIt && !giveBestGuess) {
                d.labelX = x.invert(x1);
                // we add LABEL_HEIGHT here due to a discrepancy between how circles and text are drawn.
                d.labelY = y.invert(y1 + LABEL_HEIGHT);
                d.labelAlignment = labelAlign;

                collisionList.push({
                    x: x.invert(x1),
                    y: y.invert(y1),
                    w: w1,
                    h: h1,
                    label: d.label
                });

            } else {
                returnVal = false;
                if (giveBestGuess) {
                    // we add LABEL_HEIGHT here due to a discrepancy between how circles and text are drawn.
                    returnVal = {
                        labelX: x.invert(x1),
                        labelY: y.invert(y1 + LABEL_HEIGHT),
                        labelAlignment: labelAlign
                    };
                }
            }
            return returnVal;
        };


        const circles = vis.selectAll('g.circle')
            .data(this.data)
            .enter()
            .append('g')
            .attr('class', 'circle');

        const focusCircle = function (d) {
            if (d.focus) {
                return 'x-xy-dot x-focus';
            } else {
                return 'x-xy-dot';
            }

        };

        // draw the circles
        circles.append('circle')
            .attr('class', focusCircle)
            .attr('baseclass', focusCircle)
            .attr('r', this.markerSize)
            .attr('cx', function (d) {

                return x(d.x);
            })
            .attr('cy', function (d) {
                return y(d.y);
            });

        const circleLabels = vis.selectAll('g.circle-labels')
            .data(this.data.reverse())
            .enter()
            .append('g')
            .attr('class', `${isReadOnly ? '' : 'x-hand '}circle-labels x-font-small`);
        // put the data back
        this.data.reverse();

        circleLabels.append('text')
            .attr('fill', 'white')
            .text(function (d) {
                // include text label if we can fit it.

                return (shouldShow(d, visTagList, false) ? me.trimOrdinalLabelWithFocus(d, LABEL_TRIM_LENGTH) : '');
            })
            .attr('text-anchor', function (d) {
                return d.labelAlignment ? d.labelAlignment : 'start';
            })
            .attr('alignment-baseline', 'auto')
            .attr('class', function (d) {
                let cls = 'x-dot-label x-font-small';

                if (d.focus) {
                    cls += ' x-focus';
                }

                return cls;
            })
            .attr('x', function (d) {
                return d.labelX ? x(d.labelX) : 0;
            })
            .attr('y', function (d) {
                return d.labelY ? y(d.labelY) : 0;
            });

        // for debugging collision
        if (DRAW_DEBUG_RECT) {
            const boundRect = vis.selectAll('g.rect')
                .data(visTagList)
                .enter()
                .append('g')
                .attr('class', 'rect');
            boundRect.append('rect')
                .attr('style', 'fill:none;stroke:black;')
                .attr('x', function (d) {
                    return x(d.x);
                })
                .attr('y', function (d) {
                    return y(d.y);
                })
                .attr('width', function (d) {
                    return d.w;
                })
                .attr('height', function (d) {
                    return d.h;
                });
        }
        const reAddLabels = function () {
            circleLabels
                .style('fill', 'white')
                .style('display', 'block')
                .transition()
                .duration(1000)
                .style('fill', 'black');
        };

        let labelAddTimeout;
        circles.on('mouseover', function (d) {

            clearTimeout(labelAddTimeout);
            const labelVals = shouldShow(d, dotList, true);

            const xval = (d.labelX ? x(d.labelX) : x(labelVals.labelX));
            const yval = (d.labelY ? y(d.labelY) : y(labelVals.labelY));
            d3.select(this.parentNode).append('text')
                .attr('class', 'x-popup-label x-font-small')
                .text(me.trimOrdinalLabelWithFocus(d, LABEL_TRIM_LENGTH))
                .attr('text-anchor', d.labelAlignment)
                .attr('alignment-baseline', 'baseline')
                .attr('x', xval)
                .attr('y', yval);

            if (d.focus) {

                d3.select(this).attr('class', 'x-xy-dot-selected x-focus');
            } else {

                d3.select(this).attr('class', 'x-xy-dot-selected');
            }

            circleLabels.style('display', 'none');
        });

        circles.on('mouseout', function () {

            d3.selectAll('.x-popup-label').remove();
            d3.select(this).attr('class', d3.select(this).attr('baseclass'));
            labelAddTimeout = setTimeout(reAddLabels, 100);
        });

        if (!isReadOnly) {
            d3.selectAll('.circle-labels').on('click', function (d) {

                window.location = `/company/${d.id}`;
            });
        }

        if (App.state.account.isAdmin()) {

            circles.on('click', function (d, i) {
                me.data.splice(i, 1);
                me.render();
            });
        }

    };

}, window.d3);
